// removed by extract-text-webpack-plugin
module.exports = {"tabs__content":"tabs__content","tabs__nav":"tabs__nav","scroll-content":"scroll-content","tabs__nav-item":"tabs__nav-item","active":"active","scroll-left":"scroll-left","scroll-right":"scroll-right","iScrollLoneScrollbar":"iScrollLoneScrollbar","tabs__pane":"tabs__pane","tabs_no-scroll":"tabs_no-scroll","no-slide-pane":"no-slide-pane","tabs__download-btn":"tabs__download-btn"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_tabs.scss
// module id = 101
// module chunks = 0